// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"7448785e","497":"d45849ef"}[chunkId] + ".chunk.css";
};